export default __webpack_public_path__ + "static/media/shampoo.9274a7e5.png";